/* src/app/modules/institutions/institutions-invoices/institutions-invoices.component.scss */
/*# sourceMappingURL=institutions-invoices.component.css.map */
